<template>
    <div class="HCxF">
        <atomic-search-interface class="publication-hub" fields-to-include='["publicationhubkeywords", "summary","isez120xternallink"]'  :search-hub="searchHub">
            <atomic-layout-section section="search">
                <div class="search-input-container">
                    <label class="search-label" for="search">Search</label>
                    <atomic-search-box />
                </div>
            </atomic-layout-section>
            <div class="tab-container">
                <custom-tab v-bind:label="hcxfScienceTabName"
                            expression="@publicationz32xassetz32xtype = &quot;HCxF Science&quot;"
                            is-active="true"></custom-tab>
                <custom-tab v-bind:label="ahaScienceTabName"
                            expression="@publicationz32xassetz32xtype = &quot;AHA Science Assets&quot;"
                            is-active="false"></custom-tab>
                <custom-tab v-bind:label="evidenceLibraryTabName"
                            is-active="false"></custom-tab>
            </div>
            <div v-if="tabValue === 'HCXF Science'" v-html="hcxfScienceDetail"></div>
            <div v-else-if="tabValue === 'AHA Science Assets'" v-html="ahaScienceDetail"></div>
            <div v-else v-html="evidenceLibraryDetail"></div>
            <div class="row py-4">
                <div class="col-lg-9 order-2 order-lg-1">
                    <atomic-layout-section section="main">
                        <hcxf-publication-status />
                        <hcxf-publication-search-results />
                        <div class="atomic-divider"></div>
                        <coveoPagination></coveoPagination>
                    </atomic-layout-section>
                </div>

                <div class="col-lg-3 order-1 order-lg-2">
                    <hcxf-publication-facets />
                </div>
            </div>
        </atomic-search-interface>
    </div>
</template>
<script>
    import coveoPagination from './atomic-pagination.vue'

    export default {
        data() {
            return {
                tabValue: "",
                allLinks:[]
            };
        },
        props: {
            accessToken: {
                type: String,
                required: true,
            },
            organizationId: {
                type: String,
                required: true,
            },
            searchHub: {
                type: String,
                required: true,
            },
            ahaScienceDetail: {
                type: String,
                required: true,
            },
            ahaScienceTabName: {
                type: String,
                required: true
            },
            hcxfScienceDetail: {
                type: String,
                required: true
            },
            hcxfScienceTabName: {
                type: String,
                required: true
            },
            evidenceLibraryDetail: {
                type: String,
                required: true,
            },
            evidenceLibraryTabName: {
                type: String,
                required: true
            },
            indexName: {
                type: String,
                required: true,
            },
            templateId: {
                type: String,
                required: true,
            },
        },        

        methods: {
            async initInterface() {

                await customElements.whenDefined("atomic-search-interface");
                const searchInterface = document.querySelector("atomic-search-interface");

                await searchInterface.initialize({
                    accessToken: this.accessToken,
                    organizationId: this.organizationId,
                    preprocessRequest: (request, clientOrigin, metadata) => { 
       
                        const body = JSON.parse(request.body);
                        if (clientOrigin === 'searchApiFetch') {
                            body.aq ='(@source==(\"' + this.indexName + '\") ( @z95xtemplate=' + this.templateId + '))';
                            body.searchHub = this.searchHub;
                        }
                        
                        request.body = JSON.stringify(body);
                        return request;
                    },
                });

                var engine = searchInterface.engine;
                searchInterface.executeFirstSearch();

                engine.subscribe(() => {
                    setTimeout(()=>{
                        this.checkForCardLink();
                        this.updateSpeedBump();
                        const searchBox = document.querySelector('atomic-search-box').shadowRoot;
                        if(searchBox.children[0] && searchBox.children[0].firstElementChild) {
                        const div = searchBox.children[0].firstElementChild
                        if (div) {
                            div.classList.add("w-full")
                        }
                    }  
                    },500);                                      
                });
            },
            addTabClickEventListener() {
                const shadowHost = document.querySelectorAll('.tab-container > custom-tab.hydrated').forEach(element => {
                    element.addEventListener('click', (event) => {
                        const path = event.composedPath();
                        const tabAnchor = path.find(el => el.tagName === 'A');
                        console.log(tabAnchor);
                        if (tabAnchor) {
                            this.handleTabClick(tabAnchor.innerText);
                        }
                    });

                });
            },
            handleTabClick(tabName) {                 
                this.tabValue = tabName;
            },

            checkForCardLink() {
                
                const nodes = document.querySelector('atomic-result-list').shadowRoot;
                const shadowNode = nodes.querySelectorAll("[part='result-list-grid-clickable-container outline']");
                if (shadowNode.length > 0) {
                        shadowNode.forEach(node => {
                        const resultRoot = node.querySelector('atomic-result').shadowRoot;
                        if(resultRoot) {
                            const link = resultRoot.querySelector('.result-link a')
                            const isInternalLink = resultRoot.querySelector('.isExternal') == null  ? false : true;
                            if(link && link.getAttribute('href')){
                           
                            if (isInternalLink && !link.classList.contains('twoClick')) {
                                link.classList.add('twoClick') 
                                this.allLinks.push(link);
                            } 
                        }
                        }
                    })
                }
            },
            updateSpeedBump() {
            const speedBumps = this.allLinks;
            const speedBumpLink = document.querySelector('#speed-bump-link');
            window.activeSpeedBumpLink = null;
            Array.from(speedBumps).forEach((element, index) => {
            if(!element.hasAttribute('speed-bump-set')) {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.activeSpeedBumpLink = event.currentTarget;
                    speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));
                    speedBumpLink.click();
                    });

                element.setAttribute('speed-bump-set', '');
                }
            });
            },
            getHashParam(key) {
                const hash = window.location.hash.substring(1);
                const params = new URLSearchParams(hash); 
                return decodeURIComponent(params.get(key));
            },
            updateTabValue() {
                this.tabValue = this.getHashParam("tab");
            },
        },
        mounted() {
            this.initInterface().then(() => {
                this.updateTabValue()
                this.addTabClickEventListener();
            });
        },
        components: {
            coveoPagination: coveoPagination
        }
    }
</script>
<style>
      /* custom-tab::part(tab-label) {
       color: white;
      font-size: 12px;
      padding: 5px 7px;
    }

    custom-tab::part(tab-anchor) {
      cursor: pointer;
      border: none;
      border-radius: 3px;
      text-transform: uppercase;
      background-color: #555;
    }

    custom-tab::part(active) {
      font-weight: 700;
      background-color: purple;
    }

    custom-tab::part(tab-anchor):hover {
      background-color: purple;
    } */
      atomic-search-interface {
          grid-template-areas:
              '. . atomic-section-search .'
              '. atomic-section-main atomic-section-facets .'
              '. atomic-section-facets . .';
      }

      .container-fluid:has(> .c-listing-header) {
        padding: 0;
      }

      .HCxF .c-listing-header {
        margin: 0;
        padding: 0;
        padding-top: 30px;
        @media (min-width : 768px) {
          padding-top: 30px;
        }
      }
</style>


// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-publication-hub.vue